import styled from 'styled-components';

export const BasicTileWrapper = styled.div`
  min-width: 200px;
  padding: 9px;
`;

export const MetricsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0 60px;
`;
